import lodash from "lodash";
import {
    createColumnDatetime,
    createColumnInput,
    createColumnSelect
} from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, copyForm, putField } from "../../../../../utils/form";
import { callRequestStatus, callRequestType } from "../../../storage-location/request/request.section";
import {
    createFieldInput,
    createFieldSelect,
    createFieldTextArea,
    createFieldTreeSelect
} from "../../../../../components/input/template-builder/template-builder.logic";
import { Modal } from "ant-design-vue";
import router from "../../../../../router";
import moment from "moment";
import { defineAsyncComponent } from "vue";

const CIcon = defineAsyncComponent(() => import("../../../../../components/icon/CIcon"));

export const callUserObjective = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_OBJECTIVE", value: searchQuery }).then(items => items.filter(item => ["1", "2"].includes(item.key)));
export const callDepartment = ({ searchQuery }) => store.dispatch("resource/v1/master/department/cacheFindAll", { searchQuery });
export const callDepartmentTree = () => store.dispatch("resource/v1/master/department/cacheFindAllWithChildren", {});
export const callRequestDoc = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REQUEST_DOC", value: searchQuery });

export const callCancelSequestrate = ({ approveCode, userInfo }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "refDepartment.id", type: "UUID", operator: "=", value: userInfo.refDepartment?.id },
    ];
    if (approveCode) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: approveCode });
    }
    return store
        .dispatch("resource/v1/transaction/cancelSequestrate/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "approveCode", "refUserCompany.id", "refUserCompany.fullNameTh",
                    "refRelease.id",
                    "refRelease.approveCode",
                    "refRelease.refInspection.id",
                    "refRelease.refInspection.approveCode",
                    "refRelease.refInspection.refInformTemp.id",
                    "refRelease.refInspection.refInformTemp.approveCode",
                ],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};

export const callCancelSequestrateFull = ({ id }) => {
    const criteria = {
        select: [
            "**",
            "refUserCompany.**",
            "refUser.**",
            "refDepartment.*",
            "refSequestrate.id",
            "refSequestrate.storageLocationName",
            "refSequestrate.refReleaseProduct.id",
            "refSequestrate.refReleaseProduct.refRelease.id",
            "refSequestrate.refReleaseProduct.refRelease.refInspection.id",
            "refSequestrate.refReleaseProduct.refRelease.refInspection.refInformTemp.id",
            "refSequestrate.refReleaseProduct.refRelease.refInspection.refInformTemp.approveCode",
            "refSequestrate.refReleaseProduct.refRelease.refInspection.refInformTemp.invoiceCode",
            "refSequestrate.refReleaseProduct.refInspectionProduct.refInformProduct.id",
            "refSequestrate.refReleaseProduct.refInspectionProduct.refInformProduct.invoiceCode",
        ],
        page: 0,
        size: 1,
        where: [{ name: "id", type: "UUID", operator: "=", value: id }],
        children: [
            { name: "attachments", select: ["**"], page: 0, size: 1000000, sort: [{ name: "createDate", type: "ASC" }] },
            {
                name: "products",
                select: ["**",
                    "refReleaseProduct.refInspectionProduct.refInformProduct.refHazObject.id",
                    "refReleaseProduct.refInspectionProduct.refInformProduct.refHazObject.nameTh",
                    "refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.id",
                    "refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.refSubStanceTypeMain.value",
                    "refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.tradeNameTh",
                    "refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.approveCode",
                ],
                page: 0,
                size: 1000000,
                sort: [{ name: "createDate", type: "ASC" }]
            },
            {
                name: `addresses`,
                select: ["**"],
                page: 0,
                size: 1,
                sort: [{ name: "createDate", type: "DESC" }]
            },
            {
                name: `refSequestrate.addresses`,
                select: ["**"],
                page: 0,
                size: 1,
                sort: [{ name: "createDate", type: "DESC" }]
            },
        ]
    };
    return store.dispatch("resource/v1/transaction/cancelSequestrate/search", { criteria, })
        .then(page => page.data[0])
};

export const callSequestrate = ({ approveCode, userInfo }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "refDepartment.id", type: "UUID", operator: "=", value: userInfo.refDepartment?.id },
    ];
    if (approveCode) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: approveCode });
    }
    return store
        .dispatch("resource/v1/transaction/sequestrate/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "approveCode"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};

export const callSequestrateFull = ({ id }) => {
    const criteria = {
        select: [
            "**",
            `refUserCompany.**`,
            `refUser.**`,
            `refDepartment.*`,
            `refReleaseProduct.refRelease.id`,
            `refReleaseProduct.refRelease.refInspection.id`,
            `refReleaseProduct.refRelease.refInspection.refInformTemp.id`,
            `refReleaseProduct.refRelease.refInspection.refInformTemp.approveCode`,
            `refReleaseProduct.refRelease.refInspection.refInformTemp.invoiceCode`,
            `refReleaseProduct.refInspectionProduct.refInformProduct.id`,
            `refReleaseProduct.refInspectionProduct.refInformProduct.invoiceCode`,
            "refReleaseProduct.refInspectionProduct.refInformProduct.refHazObject.id",
            "refReleaseProduct.refInspectionProduct.refInformProduct.refHazObject.nameTh",
            "refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.id",
            "refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.tradeNameTh",
        ],
        page: 0,
        size: 1,
        where: [{ name: "id", type: "UUID", operator: "=", value: id }],
        children: [
            {
                name: `addresses`,
                select: ["**"],
                page: 0,
                size: 1,
                sort: [{ name: "createDate", type: "DESC" }]
            }
        ]
    };
    return store.dispatch("resource/v1/transaction/sequestrate/search", { criteria, }).then(page => page.data[0])
};


export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.release.refUserCompany"),
            dataIndex: "refCancelSequestrateTemp.refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refCancelSequestrateTemp?.refUserCompany?.refPersonType?.key === "1"
                    ? record.refCancelSequestrateTemp?.refUserCompany?.companyNameTh
                    : record.refCancelSequestrateTemp?.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.approveCode"),
            dataIndex: "refCancelSequestrate.approveCode",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.cancelSequestrateProductInfo.invoiceCode"),
            dataIndex: "refCancelSequestrateTemp.products.refReleaseProduct.refInspectionProduct.refInformProduct.invoiceCode",
            align: "center",
            customRender: ({ record }) => {
                const labels = record.refCancelSequestrateTemp?.products?.map(d => {
                    const informProduct = d.refReleaseProduct?.refInspectionProduct?.refInformProduct;
                    return <>
                        <div>{ informProduct?.invoiceCode }</div>
                        <div>{ moment(informProduct?.invoiceDate)?.format("DD/MM/YYYY") }</div>
                    </>
                });
                return <>{...labels}</>
            }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.cancelSequestrate.refSequestrate"),
            dataIndex: "refCancelSequestrateTemp.refSequestrate.approveCode",
            align: "center"
        }),
        createColumnDatetime({
            title: () => i18n.global.t("views.request.cancelSequestrateInfo.inspectionDatetime"),
            dataIndex: "refCancelSequestrateTemp.refSequestrate.refReleaseProduct.refRelease.refInspection.inspectionDatetime",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.cancelSequestrateInfo.refRequestDoc"),
            dataIndex: "refCancelSequestrateTemp.refSequestrate.refReleaseProduct.refRelease.refInspection.refRequestDoc.value",
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.cancelSequestrate.refDepartment"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({ list: callDepartment, optLabel: "nameTh" }),
            search: { name: "refDepartment.id" },
            align: "center",
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refRequestType"),
            dataIndex: "refRequestType.value",
            customRender: ({ record }) => <div>
                <span>{record.refRequestType?.value}</span>
                {record.isSignCa ? <CIcon class="ml-1" file="sign.svg"></CIcon> : null}
            </div>,
            inputProp: () => ({ list: callRequestType, optLabel: "value" }),
            search: { name: "refRequestType.id" },
            align: "center",
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({
                list: ({searchQuery}) => callRequestStatus({ searchQuery }),
                optLabel: "value"
            }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ props, data, key }) => {
    const fields = [
        ...createFieldRequest({ props, data, key }),
    ];
    return fields;
};

export const createFieldRequest = ({ props, data, key }) => {
    const { viewOnly, requestTypeKeys } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRequestType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.refRequestType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequestType,
                            "onUpdate:value": value => {
                                model.refRequestType = value;
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callRequestType({ searchQuery }).then(d=>d.filter(d2 => requestTypeKeys?.includes(d2?.key))),
                            optLabel: "value",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}requestCode`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.requestCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requestCode,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refCancelSequestrateTemp.approveCode`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.approveCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refCancelSequestrateTemp?.approveCode,
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refCancelSequestrate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.cancelSequestrateInfo.referDoc"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.refCancelSequestrate,
                            "onUpdate:value": value => {
                                const oldValue = model.refCancelSequestrate;
                                model.refCancelSequestrate = value;
                                if (oldValue) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", {
                                            text: i18n.global.t("model.storageLocation.approveCode")
                                        }),
                                        autoFocusButton: "cancel",
                                        onOk: () => cloneCancelSequestrate({ props, model, id: value?.id }),
                                        onCancel: () => {
                                            model.refCancelSequestrate = oldValue;
                                        }
                                    });
                                } else {
                                    cloneCancelSequestrate({ props, model, id: value?.id });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callCancelSequestrate({ approveCode: searchQuery, userInfo: store.state.resource.auth.info?.user }),
                            renderLabel: ({ item }) => (
                                <div>
                                    {item.approveCode} - {item.refUserCompany?.fullNameTh}
                                </div>
                            ),
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldTreeSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refCancelSequestrateTemp.refDepartment`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.cancelSequestrate.refDepartment"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refDepartment,
                            "onUpdate:value": value => {
                                model.refDepartment = value
                                model.refCancelSequestrateTemp.refDepartment = value
                            },
                            disabled: viewOnly,
                            list: callDepartmentTree,
                            optLabel: "nameTh"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refCancelSequestrateTemp.refSequestrate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.cancelSequestrate.refSequestrate"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.refCancelSequestrateTemp.refSequestrate,
                            "onUpdate:value": value => {
                                const oldValue = model.refCancelSequestrateTemp.refSequestrate;
                                model.refCancelSequestrateTemp.refSequestrate = value;
                                if (oldValue) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", {
                                            text: i18n.global.t("model.storageLocation.approveCode")
                                        }),
                                        autoFocusButton: "cancel",
                                        onOk: () => cloneSequestrate({ props, model, id: value?.id }),
                                        onCancel: () => {
                                            model.refCancelSequestrateTemp.refSequestrate = oldValue;
                                        }
                                    });
                                } else {
                                    cloneSequestrate({ props, model, id: value?.id });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callSequestrate({ approveCode: searchQuery, userInfo: store.state.resource.auth.info?.user }),
                            optLabel: "approveCode",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forRequestRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.cancelSequestrateInfo.descToApprove"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forRequestRemark?.[0]?.remark,
                            "onUpdate:value": value => {model.lastStatus.forRequestRemark[0].remark = value},
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forApproveRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.cancelSequestrateInfo.descToRequest"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forApproveRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forApproveRemark[0].remark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
        ]
    });
};

export const cloneCancelSequestrate = ({ props, model, id }) => {
    if (id) {
        callCancelSequestrateFull({ props, id }).then(cancelSequestrate => {
            const refCancelSequestrateTemp = copyForm({ form: { ...cancelSequestrate, approveCode: null, isTemp: true } });
            if (id) {
                refCancelSequestrateTemp?.attachments?.forEach((d, index) => (d.refRealId = cancelSequestrate.attachments[index].id));
                refCancelSequestrateTemp?.products?.forEach((d, index) => {
                    d.refReal = { id: cancelSequestrate.products[index].id }
                    d.refCancelSequestrate = null;
                });
            }
            router.push({
                name: router.currentRoute.value.name,
                params: { props: JSON.stringify({ form: { ...model, refDepartment: cancelSequestrate?.refDepartment, refCancelSequestrateTemp } }) },
                query: { _timestamp: new Date().getTime() }
            });
        });
    } else {
        router.push({
            name: router.currentRoute.value.name,
            params: { props: JSON.stringify({ forceDefault: true, form: model }) },
            query: { _timestamp: new Date().getTime() }
        });
    }
};

export const cloneSequestrate = ({ props, model, id }) => {
    if (id) {
        callSequestrateFull({ props, id }).then(sequestrate => {
            const refCancelSequestrateTemp = copyForm({
                form: {
                    refSequestrate: { ...sequestrate },
                    products: [{ refReleaseProduct: sequestrate.refReleaseProduct, isSave: true }],
                    approveCode: null,
                    refDepartment: sequestrate?.refDepartment,
                    refUserCompany: sequestrate?.refUserCompany,
                    refUser: sequestrate?.refUser,
                    isTemp: true,
                }
            });
            router.push({
                name: router.currentRoute.value.name,
                params: { props: JSON.stringify({
                        form: {
                            ...model,
                            refCancelSequestrateTemp,
                            refDepartment: sequestrate?.refDepartment,
                        }
                }) },
                query: { _timestamp: new Date().getTime() }
            });
        });
    } else {
        router.push({
            name: router.currentRoute.value.name,
            params: { props: JSON.stringify({ forceDefault: true, form: model }) },
            query: { _timestamp: new Date().getTime() }
        });
    }
};